export const selectTaskCustomFields = (state) => state.customFields.items
export const selectTaskCustomFieldsIsLoaded = (state) => state.customFields.isLoaded



// WEBPACK FOOTER //
// ./web/js/customFields/selectors.js